import {Component, DestroyRef, inject} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map, take, takeUntil} from 'rxjs/operators';
import {IntentActionService} from './services/intent.action.service';
import {PortalMessageBroker} from './portal/portal-message-broker';
import {ContextInfoService, WellKnownShellProperties} from './portal/context-info.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NavigationService, Theme, ThemeService} from '@adnova/jf-ng-components';


@Component({
  selector: 'zlng-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private _intentActionService = inject(IntentActionService);
  private _portalMessageBroker = inject(PortalMessageBroker);
  private _oidcSecurityService = inject(OidcSecurityService);
  private _contextInfoService = inject(ContextInfoService);
  private _themeService = inject(ThemeService);
  private _destroyRef = inject(DestroyRef);

  runningInPortal$: Observable<boolean>;
  runningInIFrame$: Observable<boolean>;

  constructor() {
    this.runningInPortal$ = this._portalMessageBroker.runningInPortal$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
      );

    this.runningInIFrame$ = this._portalMessageBroker.runningInIFrame$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
      );

    this._contextInfoService.contextInfo$
      .pipe(
        map(info => info.properties.get(WellKnownShellProperties.SHELL_MODE) as string | undefined),
        distinctUntilChanged(),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(mode => {
        if (mode && Object.values<string>(Theme).includes(mode)) {
          this._themeService.setTheme(mode as Theme);
        }
      });
  }

  doLogout(): void {
    this._oidcSecurityService.logoff().pipe(take(1)).subscribe();
  }
}
